import { connectedStore } from '../../store';
import site from '../../site';

const isBlockOnPage = (blockId, pageId) => {
  const store = connectedStore.get();
  const state = store.getState();
  const pageUsedBlocks = site.selectors.getUsedBlocks(state, pageId);

  return pageUsedBlocks.includes(blockId);
};

export default isBlockOnPage;
